<template>
  <div>
    <div
      v-if="
        historyEventGalleryData.show &&
        historyEventGalleryData.pagePosition === 1
      "
    >
      <public-event-history-gallery
        :title="historyEventGalleryData.title"
        :items="items"
      ></public-event-history-gallery>
    </div>
    <div
      v-if="displayTemplate === 1 ? items.length : true"
      class="public-interactions"
      @error="handleMissingThumbnails"
    >
      <div
        class="public-interactions-content-classic"
        v-if="displayTemplate === 1"
      >
        <public-interactions-classic-timeline
          :items="items"
          :valueChain="valueChain"
          :image="image"
          :title="titleText"
          :description="description || ''"
        ></public-interactions-classic-timeline>
      </div>
      <div
        class="public-interactions-content"
        v-else-if="displayTemplate === 2"
      >
        <public-interactions-event-view
          :items="items"
          :valueChain="valueChain"
          :image="image"
          :title="titleText"
          :description="description || ''"
        ></public-interactions-event-view>
      </div>
    </div>
    <div
      v-if="
        historyEventGalleryData.show &&
        historyEventGalleryData.pagePosition === 2
      "
    >
      <br />
      <public-event-history-gallery
        :title="historyEventGalleryData.title"
        :items="items"
      ></public-event-history-gallery>
    </div>
  </div>
</template>

<script>
import PublicInteractionsClassicTimeline from './publicInteractionsClassicTimeline';
import PublicInteractionsEventView from './publicInteractionsEventView';
import PublicEventHistoryGallery from './publicEventHistoryGallery';

export default {
  components: {
    PublicInteractionsClassicTimeline,
    PublicInteractionsEventView,
    PublicEventHistoryGallery,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    displayTemplate: {
      type: Number,
      required: false,
      default: 1,
    },
    image: {
      type: String,
      required: false,
    },
    valueChain: {
      type: Object,
      required: false,
    },
    historyEventGalleryData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      missingThumbnails: false,
    };
  },
  computed: {
    titleText() {
      return this.title ? this.title : '';
    },
    imageExtension() {
      try {
        return this.image.match(/\.([0-9a-z]+)(?:[?#]|$)/i)[1];
      } catch (err) {
        return null;
      }
    },
  },
  methods: {
    handleMissingThumbnails() {
      this.missingThumbnails = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-interactions.scss';
</style>
